import PgxHeader from "./PgxHeader";
import GenesForSelecting from "../patientInit/pgx/GenesForSelecting";
import React from "react";
import {useTranslation} from "react-i18next";
import useDialogDrag from "../../hooks/useDialogDrag";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const CreateNewGeneView = ({ newPgx, setNewPgx, init = false, availableGeneNames, setAvailableGeneNames,
                             onHandleInitNewTest, onHandleNextClick, onHandleCancel}) => {
  const {t} = useTranslation();
  const nextDisabled = !(newPgx?.labName && newPgx?.testDate && newPgx?.genes?.length > 0);
  const { dragStyle, isDragging, onDragHandleMouseDown } = useDialogDrag(true);

  return (
    <section
      className={`create-new-gene-view dialog-draggable ${isDragging ? "dialog-draggable--dragging" : ""}`}
      style={dragStyle}
    >
      <header className="dialog-drag-header create-new-gene-view__header" onMouseDown={onDragHandleMouseDown}>
        <strong className="dialog-drag-header__title create-new-gene-view__title">{t("add_more_genes")}</strong>
        <button
          type="button"
          className="dialog-drag-close"
          onClick={onHandleCancel}
          aria-label={t("close", { defaultValue: "Close" })}
          title={t("close", { defaultValue: "Close" })}
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </header>

      <div className="create-new-gene-view__body">
        <PgxHeader newPgx={ newPgx } setNewPgx={ setNewPgx } init={ init } createNewDialogOpened={ true }/>
        <GenesForSelecting patGenes={ newPgx?.genes } onHandleInitNewTest={ onHandleInitNewTest }
                           availableGeneNames={ availableGeneNames }
                           setAvailableGeneNames={ setAvailableGeneNames }/>
      </div>

      <footer className="create-new-gene-view__footer">
        <button className="w3-btn w3-round-xlarge w3-theme-d5 create-new-gene-view__next-button" onClick={ onHandleNextClick }
                disabled={ nextDisabled }>
          { t("next") }
        </button>
      </footer>
    </section>
  )
}

export default CreateNewGeneView;